<template>
  <button
    id="telegram-button"
    v-bind="buttonProps"
    @click.stop="onClick"
  >
    <div class="d-flex align-items-center">
      <svg-icon-telegram
        :outlined="!hideText"
        :class="!hideText ? 'mr-1 mr-sm-2' : null"
        :size="isDetailView ? 18 : 24"
      />
      <span v-if="!hideText">{{ i18n.title }}</span>
    </div>
  </button>
</template>

<script>
  export default {
    components: {
      SvgIconTelegram: () =>
        import(/* webpackChunkName: "chunk-svg-icon-telegram" */ './svg/icon-telegram.vue'),
    },
    props: {
      value: {
        type: String,
        default: '',
      },
      hideText: {
        type: Boolean,
        default: false,
      },
      isDetailView: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        i18n: {
          title: gettext('Telegram'),
        },
      }
    },
    computed: {
      buttonClass() {
        return {
          btn: true,
          'btn-block': !this.hideText,
          'btn-telegram': !this.hideText,
          'btn-contact-rounded': this.hideText,
        }
      },
      buttonComponent() {
        return 'button'
      },
      buttonProps() {
        return {
          class: this.buttonClass,
          type: 'button',
        }
      },
    },
    methods: {
      onClick() {
        window.open(this.value, '_blank')
        this.$emit('analytics')
      },
    },
  }
</script>
<style>
  @media (max-width: 768px) {
    #telegram-button {
      white-space: nowrap;
    }
  }
</style>
